import React from 'react';
import type { FaixaAging } from '../types';

interface Props {
  faixas: FaixaAging[];
  modoCompacto?: boolean;
}

const fmtBRL = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
const fmtBRLCurto = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0 });

const AgingTable: React.FC<Props> = ({ faixas, modoCompacto = false }) => {
  if (modoCompacto) {
    const faixasVencidas = faixas.filter((f) => f.faixa !== 'A vencer');
    const vencidoTotal = faixasVencidas.reduce((s, f) => s + f.valor, 0);
    const maiorFaixaVencida = Math.max(1, ...faixasVencidas.map((f) => f.valor));
    return (
      <div>
        <h3 className="text-xs font-bold text-gray-800 dark:text-white mb-1">Aging da Inadimplência</h3>
        <p className="text-sm font-bold text-red-600 dark:text-red-400 mb-2">
          {fmtBRLCurto(vencidoTotal)} <span className="text-[10px] font-normal text-gray-400">total vencido</span>
        </p>
        <div className="flex items-end gap-1 h-12">
          {faixasVencidas.map((f) => (
            <div key={f.faixa} className="flex-1 flex flex-col items-center justify-end h-full">
              <div
                className="w-full rounded-t"
                style={{ height: `${Math.max(4, (f.valor / maiorFaixaVencida) * 100)}%`, backgroundColor: f.faixa === '+90' ? '#dc2626' : '#f59e0b' }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const maiorValor = Math.max(1, ...faixas.map((f) => f.valor));

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 shadow-sm p-4">
      <h3 className="text-sm font-bold text-gray-800 dark:text-white mb-3">Aging da Inadimplência</h3>
      <div className="flex flex-col gap-2">
        {faixas.map((f) => {
          const destaque = f.faixa === '+90';
          return (
            <div key={f.faixa} className="flex items-center gap-3 text-sm">
              <span className={`w-16 shrink-0 text-gray-500 dark:text-gray-400 ${destaque ? 'font-bold text-red-600 dark:text-red-400' : ''}`}>
                {f.faixa}
              </span>
              <div className="flex-1 h-4 bg-gray-100 dark:bg-gray-900/40 rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${(f.valor / maiorValor) * 100}%`, backgroundColor: destaque ? '#dc2626' : '#f59e0b' }}
                />
              </div>
              <span className={`w-24 text-right shrink-0 ${destaque ? 'font-bold text-red-600 dark:text-red-400' : 'text-gray-600 dark:text-gray-300'}`}>
                {fmtBRL(f.valor)}
              </span>
              <span className="w-16 text-right shrink-0 text-gray-400 text-xs">{f.qtde} bol.</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AgingTable;
